<template>
  <div class="recycle-banner-component">
    <div class="banner-content">
      <div class="banner-body box">
        <div>
          <img class="icon-banner-logo" src="./img/icon_banner_logo.png" />
          <div class="client-list">
            <div
              v-for="(item, index) in clientList"
              :key="index"
              class="client-item"
              @click="$emit('qrcode', item)"
            >
              <el-popover
                placement="bottom"
                trigger="hover"
                :visible-arrow="false"
                :close-delay="0"
                @show="popoverChange('show', item)"
                @hide="popoverChange('hide', item)"
              >
                <div class="home-client-center">
                  <img class="icon-client" :src="item.qrcode" />
                </div>
                <div slot="reference" class="client-image">
                  <img class="icon-client" :src="item.show ? item.selIcon : item.icon" />
                </div>
              </el-popover>
            </div>
          </div>
        </div>
        <div>
          <img class="icon-banner-main" src="./img/icon_banner_main.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Popover } from 'element-ui';

export default {
  components: {
    [Popover.name]: Popover
  },
  data () {
    return {
      clientList: [
        {
          name: 'app',
          title: '回收宝APP',
          buttonText: '加价回收',
          show: false,
          titleIcon: require('./img/icon_app_download_title.png'),
          qrcode: require('./img/icon_app_download.png'),
          icon: require('./img/icon_app_btn.png'),
          selIcon: require('./img/icon_app_btn_sel.png')
        },
        {
          name: 'wechatmini',
          title: '微信小程序',
          buttonText: '加价回收',
          show: false,
          titleIcon: require('./img/icon_wechatmini_products_title.png'),
          qrcode: require('./img/icon_wechatmini_products.png'),
          icon: require('./img/icon_mini_btn.png'),
          selIcon: require('./img/icon_mini_btn_sel.png')
        },
        {
          title: 'wechat',
          buttonText: '订阅更多惊喜福利',
          show: false,
          titleIcon: require('./img/icon_wechatmini_gzh_title.png'),
          qrcode: require('./img/icon_wechatmini_gzh.png'),
          icon: require('./img/icon_gzh_btn.png'),
          selIcon: require('./img/icon_gzh_btn_sel.png')
        }
      ]
    };
  },
  methods: {
    popoverChange (status, item) {
      item.show = !item.show;
    }
  }
};
</script>

<style scoped>
  .banner-content {
  padding: 35px 0;
  height: 400px;
  background: linear-gradient(180deg,#ffed3a, #fff34b 46%, #fffddf);
  .banner-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .icon-banner-logo {
    width: 433px;
    height: 127px;
  }
  .client-list {
    margin-top: 34px;
    display: flex;
    .client-item {
      margin-right: 16px;
      cursor: pointer;
      .client-image {
        width: 130px;
        height: 40px;
        .icon-client {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .icon-banner-main {
    width: 630px;
    height: 330px;
  }
}
.home-client-center {
  .icon-client {
    width: 180px;
    height: 180px;
  }
}
.box {
  margin: 0 auto;
  width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/components/recycle-banner.vue